{
  "useInheritedPermissions": "Vererbte {{ resource }} -Berechtigungen verwenden",
  "permissions": "Berechtigungen",
  "addUserOrGroup": "Benutzer oder Gruppe hinzufügen",
  "additionalPermissions": "Zusätzliche Berechtigungen",
  "inheritedPermissions": "Vererbte Berechtigungen",
  "turnOffInheritance": "Schalten Sie die Vererbung aus",
  "turnOnInheritance": "Schalten Sie die Vererbung ein",
  "turnOnInheritanceDescription1": "Wenn Sie diese Option aktivieren, setzen Sie die vom übergeordneten Objekt übernommenen Berechtigungen wieder in Kraft.",
  "turnOnInheritanceDescription2": "Beachten Sie, dass alle zusätzlichen Berechtigungen für dieses Element verloren gehen, wenn Sie diese Option erneut aktivieren.",
  "turnOffInheritanceDescription1": "Wenn Sie diese Option deaktivieren, können Sie die Berechtigungen aller Benutzer und Benutzergruppen anpassen.",
  "turnOffInheritanceDescription2": "Beachten Sie, dass durch das Unterbrechen der Vererbungskette alle zukünftigen Änderungen, die an den Berechtigungen des übergeordneten Elements vorgenommen werden, nicht an dieses Objekt weitergegeben werden.",
  "inheritanceChangesSaved": "Änderungen an der Vererbung werden automatisch gespeichert.",
  "authLevels": {
    "admin": {
      "title": "Voller Zugriff",
      "descriptionPlan": "Zugriff bearbeiten sowie Berechtigungen löschen, umbenennen und verwalten",
      "descriptionFolder": "Pläne und Ordner erstellen, umbenennen und löschen",
      "descriptionLayer": "Zugriff bearbeiten sowie Berechtigungen löschen, umbenennen und verwalten"
    },
    "write": {
      "title": "Bearbeiten",
      "descriptionPlan": "Objekte und Attribute erstellen und bearbeiten",
      "descriptionFolder": "Kann Pläne und Unterordner hinzufügen",
      "descriptionLayer": "Objekte und Attribute erstellen und bearbeiten"
    },
    "read": {
      "title": "Ansehen",
      "descriptionPlan": "Kann den Plan ansehen und Kommentare hinzufügen",
      "descriptionFolder": "Kann den Inhalt von Ordnern einsehen",
      "descriptionLayer": "Kann die zu dieser Ebene gehörenden Objekte sehen"
    },
    "deny": {
      "title": "Kein Zugriff",
      "descriptionPlan": "Der Plan kann nicht angezeigt werden",
      "descriptionFolder": "Ordnerinhalte können nicht angezeigt werden",
      "descriptionLayer": "Objekte, die zu dieser Ebene gehören, können nicht angezeigt werden"
    }
  },
  "usersGroups": {
    "searchLabel": "Geben Sie einen Namen oder eine Gruppe ein",
    "searchTitle": "Suchen Sie nach einem Kollegen"
  },
  "permissionsEditTitle": "Legen Sie {{ nodeType }} Bearbeitungsberechtigungen fest",
  "resourceLockDescription1": "Die Berechtigungen sind gesperrt und niemand kann Änderungen vornehmen.",
  "resourceLockDescription2": "Administratoren können die Sperre jederzeit entsperren.",
  "unlockButtonText": "Entsperren, um die Bearbeitung zu ermöglichen",
  "inheritedLockDescription1": "Aufgrund einer kaskadierenden Sperre durch ein übergeordnetes Objekt kann niemand Änderungen vornehmen.",
  "inheritedLockDescription2": "Administratoren können die Sperre entsperren, indem sie zu den übergeordneten Einstellungen gehen.",
  "lock": "Sperren",
  "inheritedPermissionsHelpText": "Wenn diese Einstellung aktiviert ist, verwendet dieses Objekt die vom übergeordneten Objekt festgelegten Berechtigungen.",
  "linkExpiredModal": {
    "title": "Link ist abgelaufen",
    "content": "Dieser Link ist abgelaufen oder ungültig.\n Wenden Sie sich an den Benutzer, der den Link erstellt hat, wenn Sie Zugriff benötigen."
  },
  "copyPermissions": "Berechtigungen kopieren"
}